<template>
    <div class="border rounded-md border-branding-simple-grey p-4 mb-6">
        <div class="text-branding-cool-grey text-base leading-8 my-2">{{ $t('settings.credit.buy') }}</div>
        <div class="flex flex-col md:flex-row text-base justify-between md:items-center">
            <div class="flex items-center">
                <i class="fa-solid fa-coin"></i>
                <i class="fa-solid fa-coin text-branding-active-grey"></i>
                <div class="ml-2">10 {{ $t('settings.sidebar.credit') }} = {{ $priceFromEuros(10 * props.creditPrice) }}</div>
            </div>
            <div class="flex items-center gap-2">
                <div>{{ $t('settings.credit.count') }} :</div>
                <select
                    v-model="creditCount"
                    class="bg-branding-white px-1 py-2 border border-branding-simple-grey text-right rounded-md w-28"
                >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
        </div>

        <div class="ml-2">
            <div class="text-sm mb-4">
                {{ $t('settings.credit.meaning') }}
            </div>
            <div class="flex justify-between font-semibold mb-4">
                <div>{{ $t('misc.total') }}</div>
                <div>{{ $priceFromEuros(totalPrice) }}</div>
            </div>
        </div>

        <div class="flex justify-end">
            <LoadingButton
                :loading="loading"
                class-name="px-6 h-10 rounded-lg whitespace-nowrap bg-branding-brand-yellow hover:bg-branding-mustard font-semibold text-branding-rich-black relative w-full md:w-fit"
                @clicked="buy"
            >
                {{ $t('settings.credit.buy') }}
            </LoadingButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import EndpointFactory from '~/app/factories/EndpointFactory';

    const emit = defineEmits<{
        (e: 'purchased'): void;
    }>();

    const props = defineProps<{
        creditPrice: number;
    }>();

    const creditCount = ref(10);
    const loading = ref(false);

    const totalPrice = computed(() => {
        return creditCount.value * props.creditPrice;
    });

    const buy = async () => {
        loading.value = true;
        const endpoint = EndpointFactory.subscription();
        const response = await endpoint.buyCredits(creditCount.value);

        if (!response) {
            loading.value = false;
            return;
        }
        useToasteoSuccess();
        emit('purchased');
        loading.value = false;
        useEvent('settings:credit:credit-modal:close');

        const { $tracker } = useNuxtApp();
        $tracker.track('credit_purchased', { count: creditCount.value, total: totalPrice.value });
    };
</script>
